import { type ScanCode } from "../utils/getLensScanCode";

const saveBlob = (blob: Blob, fileName: string): void => {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => {
        URL.revokeObjectURL(objectUrl);
    });
};

// Browsers ignore `download` on cross-origin URLs and just display the image, so fetch it
// (the QR CDN allows CORS) and save it through a same-origin object URL instead.
// Rejects when the image cannot be fetched; callers show the failure inline. Opening the
// URL in a new tab is not a usable fallback here: popup blockers stop `window.open` after an await.
export const downloadLensScanCode = async ({ downloadUrl, downloadFormat }: ScanCode): Promise<void> => {
    const response = await fetch(downloadUrl);
    if (!response.ok) {
        throw new Error(`QR code download failed: ${response.status}`);
    }
    saveBlob(await response.blob(), `lens-qr-code.${downloadFormat}`);
};
